import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const removeEmergentBadge = () => {
  document
    .querySelectorAll('[id*="emergent"], [class*="emergent"], a[href*="emergent.sh"]')
    .forEach((element) => element.remove());

  document.querySelectorAll("a, button, div, span").forEach((element) => {
    const label = element.textContent?.trim().toLowerCase();
    if (label === "made with emergent") {
      element.remove();
    }
  });
};

removeEmergentBadge();
new MutationObserver(removeEmergentBadge).observe(document.documentElement, {
  childList: true,
  subtree: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
